import Svg, { Circle, Defs, G, LinearGradient, Path, Rect, Stop } from 'react-native-svg'

export const Support = ({}: { height?: any; width?: any; color?: any }) => {
  return (
    <Svg width="150" height="125.253" viewBox="0 0 150 125.253">
      <Defs>
        <LinearGradient
          id="linear-gradient"
          x1="0.973"
          y1="0.997"
          x2="-0.004"
          y2="0.106"
          gradientUnits="objectBoundingBox">
          <Stop offset="0" stop-opacity="0.502" />
          <Stop offset="1" stop-opacity="0" />
        </LinearGradient>
        <LinearGradient
          id="linear-gradient-2"
          x1="0.981"
          y1="0.984"
          x2="0.021"
          y2="0.047"
          gradientUnits="objectBoundingBox">
          <Stop offset="0" stop-color="#fff" stop-opacity="0.702" />
          <Stop offset="1" stop-color="#fff" stop-opacity="0.078" />
        </LinearGradient>
      </Defs>
      <G id="Group_1368" data-name="Group 1368" transform="translate(-763.345 -210.582)">
        <Circle
          id="Ellipse_51"
          data-name="Ellipse 51"
          cx="51.856"
          cy="51.856"
          r="51.856"
          transform="translate(777.877 232.124)"
          fill="#f8f8f8"
        />
        <G id="send-24px" transform="translate(789.366 243.296) rotate(-30)">
          <Path
            id="Path_228"
            data-name="Path 228"
            d="M0,0H86.339V86.339H0Z"
            transform="translate(0 12.073)"
            fill="none"
          />
          <Path
            id="Path_227"
            data-name="Path 227"
            d="M.036,64.754,75.547,32.377.036,0,0,25.182l53.962,7.195L0,39.572Z"
            transform="translate(7.195 22.866)"
            fill="#0186b0"
          />
          <Path
            id="Path_309"
            data-name="Path 309"
            d="M3.189,0,54.906,16.129,0,6.481Z"
            transform="translate(4.521 63.845) rotate(-25)"
            fill="url(#linear-gradient)"
          />
          <Path
            id="Path_310"
            data-name="Path 310"
            d="M3.062,0,57.121,60.708,0,5.995Z"
            transform="translate(4.561 24.14) rotate(-25)"
            fill="url(#linear-gradient-2)"
          />
        </G>
        <Rect
          id="Rectangle_436"
          data-name="Rectangle 436"
          width="39.509"
          height="3.292"
          rx="1.646"
          transform="translate(763.345 305.395) rotate(-30)"
          fill="#0186b0"
          opacity="0.21"
        />
        <Rect
          id="Rectangle_437"
          data-name="Rectangle 437"
          width="14.816"
          height="3.292"
          rx="1.646"
          transform="translate(789.668 319.388) rotate(-30)"
          fill="#0186b0"
          opacity="0.21"
        />
        <Rect
          id="Rectangle_438"
          data-name="Rectangle 438"
          width="31.278"
          height="3.292"
          rx="1.646"
          transform="translate(791.874 304.572) rotate(-30)"
          fill="#0186b0"
          opacity="0.21"
        />
      </G>
    </Svg>
  )
}
